/**
 * Search filter for resource listings
 */

import { createComponent } from "react-fela";
import { colors } from "~/styleguide";

export default function SearchBar({ children, value, handleSearchChange }) {
    return (
        <div>
            <Input
                type="text"
                value={value}
                onChange={handleSearchChange}
                placeholder="Click here to search"
            />
            {children && children}
        </div>
    );
}

const Input = createComponent(() => ({
        border: "1px solid black",
        borderRadius: 6,
        height: 54,
        outline: 0,
        appearance: "none",
        padding: 12,
        paddingRight: 50,
        width: "100%",
        transition: "border-color 0.2s ease",
        willChange: "border-color",

        whenActive: {
            borderColor: colors.blue
        },

        "::placeholder": {
            color: "black"
        },

        ":active": {
            borderColor: colors.blue
        },
        ":focus": {
            borderColor: colors.blue
        }
    }),
    "input",
    ["type", "onChange", "value", "placeholder"],
);
